"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCreateVerificationSessionDto = instanceOfCreateVerificationSessionDto;
exports.CreateVerificationSessionDtoFromJSON = CreateVerificationSessionDtoFromJSON;
exports.CreateVerificationSessionDtoFromJSONTyped = CreateVerificationSessionDtoFromJSONTyped;
exports.CreateVerificationSessionDtoToJSON = CreateVerificationSessionDtoToJSON;
exports.CreateVerificationSessionDtoToJSONTyped = CreateVerificationSessionDtoToJSONTyped;
/**
 * Check if a given object implements the CreateVerificationSessionDto interface.
 */
function instanceOfCreateVerificationSessionDto(value) {
    if (!('returnUrl' in value) || value['returnUrl'] === undefined)
        return false;
    return true;
}
function CreateVerificationSessionDtoFromJSON(json) {
    return CreateVerificationSessionDtoFromJSONTyped(json, false);
}
function CreateVerificationSessionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'returnUrl': json['returnUrl'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}
function CreateVerificationSessionDtoToJSON(json) {
    return CreateVerificationSessionDtoToJSONTyped(json, false);
}
function CreateVerificationSessionDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'returnUrl': value['returnUrl'],
        'type': value['type'],
    };
}
